import * as React from "react";
import AuthService from "../../Components/auth/AuthService";
import Autocomplete from '@mui/material/Autocomplete';
import { Box, styled } from "@mui/system";
import Stack from '@mui/material/Stack';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { useLoadingDispatch, showLoading, hideLoading } from '../../context/loadingContext';
import { locationTypes, yesNo } from "../../Components/common/Constants";
import { Button, Row, Col, Input, Select, message, Descriptions, Tag, Flex, Tooltip, Table } from "antd";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { showMessage } from "../../Components/Utils/message";
import { decodeId } from "../../Components/common/CommonFun";
import { InfoCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const Auth = new AuthService();
const DataSheet = styled('div')`
   .ant-input-number-disabled {
      background: none;
      color: black;
    }
   .ant-select-outlined.ant-select-disabled .ant-select-selector {
      background: rgb(240, 240, 240);
      color: black;
    },
`;
export default function TransactionsOpeningBalance(props) {

  const navigate = useNavigate();
  const params = useParams();
    const decodedID = decodeId(params?.id)

  const { Option } = Select
  var layoutDispatch = useLoadingDispatch();
  const dispatch = useDispatch()
  const { products, locations } = useSelector((state) => state?.AppState?.userCreds);
  const [selectedProductLocations, setSelectedProductLocations] = React.useState([]);
  const [batchTransactions, setBatchTransactions] = React.useState([]);

  const [id, setId] = React.useState(decodedID ? decodedID : 0);
  const [openingDetails, setOpeningDetails] = React.useState({

    product: null,
    location: null,
    quantity: null,
  });

  const getStockBatches = async () => {
    
      showLoading(layoutDispatch);
      try {
        const res = await Auth.fetch(`/ob/stock-batches?opening_balance_id=${id}`);
        if (res?.ack) {
  
          setBatchTransactions(res?.stock_batches || []);
        } else {
          showMessage('error', res?.message);
          setBatchTransactions([]);
        }
      } catch (error) {
        console.error("Error fetching stock batches:", error);
        showMessage('error', "Something went wrong while fetching stock batches");
        return;
      } finally {
        hideLoading(layoutDispatch);
      }
  
    };

  const getDataByID = async () => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/ob/opening-balance?id=${id}`);
      if (res.ack) {
        setOpeningDetails({
          ...openingDetails,
          location: res?.opening_balance?.location_id,
          product: res?.opening_balance?.product_netsuite_id,
          quantity: res?.opening_balance?.quantity,
          originalQuantity: res?.opening_balance?.quantity,
          addedQuantity: res?.opening_balance?.added_quantity,
          posted: res?.opening_balance?.posted_by > 0 ? true : false
        })
      }
      getStockBatches()
    } catch (error) {
      showMessage('error', "Something went wrong");
    } finally {
      hideLoading(layoutDispatch);
    }

  }

  React.useEffect(() => {
    if (id > 0) {
      getDataByID()
    }


  }, []);

  const onClickCancel = () => {
    navigate("/transaction-ob");
  };

  const getAllPro = async () => {
    showLoading(layoutDispatch)
    try {

      const res = await Auth.fetch(`/product/products`);
      if (res.ack) {
        if (res?.products.length > 0) {
          const newTimestamp = new Date().getTime();
          dispatch({
            type: 'SET_PRODUCTS',
            payload: { products: res?.products, timestamp: newTimestamp },
          });
        }

        // setProducts(res?.products)
      } else {
        showMessage('error', res.message);
      }
    } catch (error) {
      console.log(error);
      showMessage('error', "Something went wrong");
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const handleSubmit = async () => {

    const isEmptyOrUndefined = (value) => value === '' || value === null || value === undefined;
    const validations = [
      // { key: 'location', message: 'Please add location' },
      { key: 'product', message: 'Please add product' },
      { key: 'quantity', message: 'Please add location type' },
    ];

    for (const { key, message: errorMessage } of validations) {
      if (isEmptyOrUndefined(openingDetails?.[key])) {
        showMessage('error', errorMessage);
        return;
      }
    }
    showLoading(layoutDispatch);
    const isUpdate = id > 0;
    const dataToSend = {
      id: isUpdate ? id : undefined,
      quantity: openingDetails.quantity,
      // location_id: openingDetails.location,
      product_netsuite_id: openingDetails.product,
    }
    try {
      const method = isUpdate ? "PUT" : "POST";
      const res = await Auth.fetch("/ob/opening-balance", {
        method: method,
        body: JSON.stringify(dataToSend),
      })
      if (res?.ack) {
        getAllPro();
        showMessage('success', res?.message)
        navigate('/transaction-ob');
      } else {
        showMessage('error', res?.message)
      }

    } catch (err) {
      console.log(err);
    }
    finally {
      hideLoading(layoutDispatch);
    }
  };


   const batchCol = [
   
       {
         title: "Batch Code",
         dataIndex: 'batch_code',
         key: 'batch_code',
       },
       {
              title: "Expiry",
              render: (record) => {
                const expiry = record?.expiry_date;
                if (!expiry) return "";
        
                const expiryDate = dayjs(expiry, "YYYY-MM-DD");
                const today = dayjs();
                const diffDays = expiryDate.diff(today, "day");
        
                let color = "green";
                if (diffDays < 0) {
                  color = "red";
                } else if (diffDays <= 7) {
                  color = "orange";
                }
        
                return <Tag style={{ fontSize: '15px' }} color={color}>{record?.expiry_date}</Tag>;
              }
            },
   
       {
         title: "Supplier Batch Code",
         dataIndex: 'supplier_batch_code',
         key: 'supplier_batch_code',
       },
       {
         title: "Quantity",
         dataIndex: 'quantity',
         key: 'quantity',
         render: (quantity) => {
           return <Tag color='green' style={{ fontSize: 16, fontWeight: 'bold' }}>{Number(quantity)?.toLocaleString() || 0} </Tag>;
         },
         align: 'center',
       },
       {
         title: "User",
         render(record) {
           if (!record) return "";
   
           const user = record?.user_name || "";
           const helper = record?.helper_name || "";
   
           if (helper) {
             return (
               <>
                 {helper}{" "}
                 {user && (
                   <Tooltip title={`${user}`}>
                     <InfoCircleOutlined style={{ fontSize: 16, marginLeft: 6, color: "#1890ff" }} />
                   </Tooltip>
                 )}
               </>
             );
           }
   
           return <>{user}</>;
         }
       },
           ];

  return (
    <DataSheet>
      <Flex align="center" justify="space-between">
        <h3 style={{ margin: 0 }}>{id > 0 ? "Update" : "Add"} Opening Balance</h3>
        {
          openingDetails?.posted  && (
            <Tag color="red" style={{ fontSize: "16px", fontWeight: "bold" }}>
              Posted
            </Tag>
          )
        }
      </Flex>

      {id > 0 && (
        <Descriptions
          bordered
          size={"small"}
          style={{ marginTop: "5px", marginBottom: "15px", flexWrap: "wrap", width: "100%" }}
          column={{ xs: 1, sm: 2, md: 2, lg: 5 }}
        >
          <Descriptions.Item label={"Initial Quantity"} labelStyle={{ fontWeight: "bold", width: '290px' }}>
            <Tag style={{ fontSize: "12px", fontWeight: "bold" }} color="blue">
              {openingDetails.originalQuantity?.toLocaleString()}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label={"Added Quantity"} labelStyle={{ fontWeight: "bold", width: '290px' }}>
            <Tag style={{ fontSize: "12px", fontWeight: "bold" }} color="blue">
              {openingDetails?.addedQuantity?.toLocaleString() || 0}
            </Tag>
          </Descriptions.Item>
        </Descriptions>
      )}
      <Row gutter={[16, 16]}>

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <span>
            Product<span style={{ color: "red" }}>*</span>
          </span>
          <Select
            style={{
              width: "100%",
            }}
            showSearch
            allowClear
            value={openingDetails.product}
            placeholder="Product"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
            disabled={id > 0}
            onChange={(value) => {
              const selectedProduct = products?.find((pro) => pro?.netsuite_id == value)

              const productLocations = selectedProduct?.product_locations
                ? selectedProduct.product_locations.split(',').map((id) => Number(id.trim()))
                : [];
              const matchedLocations = locations.filter(location =>
                productLocations.includes(location.id)
              );
              setSelectedProductLocations(matchedLocations);
              setOpeningDetails({ ...openingDetails, product: value })
            }
            }
          >
            {products?.map((item) => (
              <Option key={item?.netsuite_id} value={item?.netsuite_id}>
                {` ${item?.code} - ${item?.name} `}
              </Option>
            ))}
          </Select>
        </Col>
        {/* <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Location<span style={{ color: "red" }}>*</span>
            </span>
            <Select
              style={{
                width: "100%",
              }}
              showSearch
              allowClear
              value={openingDetails.location}
              placeholder="Location"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => setOpeningDetails({ ...openingDetails, location: value})}
            >
              {selectedProductLocations?.map((item) => (
                <Option key={item?.id} value={item?.id}>
                  {` ${item?.code} - ${item?.title} `}
                </Option>
              ))}
            </Select>
          </Col> */}

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <span>
            Quantity<span style={{ color: "red" }}>*</span>
          </span>
          <Input
            type="number"
            value={openingDetails?.quantity}
            disabled={openingDetails?.posted}
            placeholder="Quantity"
            onChange={(e) => {
              const newValue = e.target.value
              if (e.target.value.includes('.')) return;
              if (newValue < 0) return showMessage('error', 'Quantity cannot be negative');
              if (openingDetails?.addedQuantity) {
                if (newValue < openingDetails?.addedQuantity) return showMessage('error', 'Quantity can not be less than already added quantity')
              }
              setOpeningDetails({ ...openingDetails, quantity: newValue })
            }}
          />
        </Col>
      </Row>
      <Flex justify="end" gap={10} style={{ marginTop: "40px" }}>
        <Button

          onClick={onClickCancel}
        >
          Cancel
        </Button>
      {
        !openingDetails?.posted && (
        
        <Button type="primary" onClick={handleSubmit}>
          Save
        </Button>

        )
      }
      </Flex>

      {
                  batchTransactions?.length > 0 && (
                    <Table
                      dataSource={batchTransactions}
                      columns={batchCol}
                      pagination={false}
                      style={{ marginTop: "10px" }}
                      scroll={{ x: 'max-content' }}
                      rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
                    />
                  )
                }
      
    </DataSheet>
  );
}
